/**
 * @generated SignedSource<<aa777be0772896d743cd712dacc0663b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedBillboardAd_itemSearch$data = {
  readonly displayUriRef: string | null;
  readonly " $fragmentType": "SbSharedBillboardAd_itemSearch";
};
export type SbSharedBillboardAd_itemSearch$key = {
  readonly " $data"?: SbSharedBillboardAd_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedBillboardAd_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedBillboardAd_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "cf87c77b8210f4aef685eb02e7c9deca";

export default node;
